import { render } from "./expertTitle.vue?vue&type=template&id=1678dbfa&scoped=true"
import script from "./expertTitle.vue?vue&type=script&lang=js"
export * from "./expertTitle.vue?vue&type=script&lang=js"

import "./expertTitle.vue?vue&type=style&index=0&id=1678dbfa&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1678dbfa"]])

export default __exports__